"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * returns a number type representation of the input string or null if it is not a number
 * @param n
 */
function stringToNumber(n) {
    if (n === null || n === undefined)
        return null;
    if (n === '0' || n === 0)
        return 0;
    if (n.toString().substr(-1) !== '0')
        return + +n || null;
    if (n.toString().indexOf('.') === -1) {
        var val = parseInt(n.toString(), 10);
        if (isNaN(val))
            return null;
        else
            return val;
    }
    else {
        var fp = parseFloat(n.toString());
        if (isNaN(fp))
            return null;
        else
            return fp;
    }
}
exports.stringToNumber = stringToNumber;
/**
 * returns number of places to the right of decimal (if any) in the string input of a number
 * @param num
 */
function decPlaces(num) {
    if (Math.floor(num) === num || !num)
        return 0;
    else
        return (num.toString().split('.')[1] || []).length;
}
exports.decPlaces = decPlaces;
function formatBytesForString(bytes) {
    if (bytes < 1024) {
        return bytes + ' bytes';
    }
    else if (bytes >= 1024 && bytes < 1048576) {
        return (bytes / 1024).toFixed(1) + ' KB';
    }
    else if (bytes >= 1048576) {
        return (bytes / 1048576).toFixed(1) + ' MB';
    }
}
exports.formatBytesForString = formatBytesForString;
/**
 * returns number with commas removed from string, maintaining decimal precision
 * @param {string} numberStr
 * @param {number} decimalPlaces
 */
function removeCommas(numberStr, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = null; }
    if (!numberStr)
        return null;
    if (decimalPlaces === null || decimalPlaces === undefined) {
        return parseFloat(numberStr.replace(/,/g, ''));
    }
    else {
        return parseFloat(numberStr.replace(/,/g, '')).toFixed(decimalPlaces);
    }
}
exports.removeCommas = removeCommas;
/**
 * Convert the given int to a guid.
 * @param {number} int The number to convert to a guid.
 * @returns {string} A guid representation of the provided integer.  For example, the number 2 becomes '00000002-0000-0000-0000-000000000000'
 */
function convertIntToGuid(int) {
    if (int < 0) {
        int = 0xFFFFFFFF + int + 1;
    }
    var converted = int.toString(16).toUpperCase();
    var padded = pad(converted, 8, '0');
    return padded + '-0000-0000-0000-000000000000';
}
exports.convertIntToGuid = convertIntToGuid;
/**
 * Convert given guid to an int.
 * @param {string} guid The guid to convert to an integer.
 * @returns {number} An integer.
 */
function convertGuidToInt(guid) {
    var hex = '0x' + guid.substring(0, 8);
    var result = parseInt(hex, 16);
    return result;
}
exports.convertGuidToInt = convertGuidToInt;
/**
 * Pad out the given converted number with zeros.  For example, if the converted number is 10, and width is 4, the result will be '0010'
 * @param {number} convertedNumber The number to pad.
 * @param {*} width Total number of characters to return.
 * @param {*} padChar The character to pad with.  By default, this is '0'.
 */
function pad(convertedNumber, width, padChar) {
    padChar = padChar || '0';
    convertedNumber += '';
    return convertedNumber.length >= width ? convertedNumber : new Array(width - convertedNumber.length + 1).join(padChar) + convertedNumber;
}
exports.pad = pad;
//# sourceMappingURL=number-utilities.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/utilities/number-utilities.js
// module id = 1156
// module chunks = 0